import { ClientsByOKED } from '@/app/api/types';
import { UITable } from '@/shared/ui/ui-table';
import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

interface FactorReportTableProps {
  data?: ClientsByOKED[];
}

export const FactorReportTable: FC<FactorReportTableProps> = ({ data }) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        border: '1px solid #DBDFED',
        borderColor: '#DBDFED',
        borderRadius: '6px',
        px: 3,
      }}
    >
      <UITable
        data={data ?? []}
        columns={[
          { label: t('oked_name'), key: 'OKEDName' },
          {
            label: t('clients_count'),
            key: 'number',
          },
        ]}
        sx={{
          '& .MuiTableCell-root': {
            fontSize: '1.5rem',
            fontWeight: 500,
            color: '#0B1370',
            borderColor: '#DBDFED',
          },
          '& .MuiTableHead-root .MuiTableCell-root': {
            fontSize: '2rem',
            fontWeight: 600,
            color: '#0B1370',
          },
          '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root':
            {
              borderBottom: 'none',
            },
        }}
      />
    </Box>
  );
};
